export default __webpack_public_path__ + "static/BAP_4444-Verbessert-NR_rgb_fine-a7cd8d91e5666d348e491df4fcc9f8a6.jpg";